// extracted by mini-css-extract-plugin
module.exports = {"card__cost":"card-cost_card__cost__16BM_","cost--decreased":"card-cost_cost--decreased__PTqYF","cost--increased":"card-cost_cost--increased__fXFOy"};